import { USER } from "@/store/types";
import { getStorageItem } from "@/utils/storage";
import eventBus from "@/utils/eventBus";

export default {
  data() {
    return {
      ws: null
    };
  },
  created() {
    const user = getStorageItem(USER);
    // let token = getStorageItem(ACCESS_TOKEN);
    // const wsToken = token.substring(7);
    const websocketUrl = process.env.VUE_APP_WEBSOCKET_URL;
    const userId = user.id;
    const ws = new WebSocket(`${websocketUrl}/webSocket/${userId}`);
    this.ws = ws;
    ws.onopen = function() {
      ws.send("connect server");
    };
    ws.onmessage = function(evt) {
      const received_msg = evt.data;
      if (received_msg.startsWith("{") && received_msg.endsWith("}")) {
        try {
          // const result = JSON.parse(received_msg);
          eventBus.$emit("reciveMessage");
        } catch (e) {
          console.log(e);
        }
      }
      console.log(received_msg);
    };
    // 关闭时调用
    ws.onclose = function() {
      console.log("websocket close");
    };
    // 发生错误时调用
    ws.onerror = function(err) {
      console.error(err);
    };
  },
  beforeDestroy() {
    this.ws.close();
  }
};
